import './styles.scss'

export default function NotifyError({ title, description }) {
    return (
        <div className='notification-error'>
            <div className='notification-error-alert'>
                <div className='notification-error-alert-icon'>
                    <em className='fas fa-exclamation' />
                </div>
                <div className='notification-error-alert-text'>
                    <p>{title}</p>
                    <span>{description}</span>
                </div>
            </div>
        </div>
    )
}